import { makeStyles } from 'tss-react/mui';

import { TokenSize } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ size: TokenSize }>()((theme, { size }) => ({
  avatar: {
    background: theme.primary.p2,

    '&.MuiAvatar-root': {
      borderWidth: 1,
      boxSizing: 'border-box',
      position: 'relative',

      '&:before': {
        top: 0,
        left: 0,
        content: '""',
        width: '100%',
        height: '100%',
        position: 'absolute',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundImage: 'url(../icons/unknownLogo.svg)',
      },

      '& .MuiSvgIcon-root': {
        display: 'none',
      },

      '& img': {
        zIndex: 2,
      },
    },

    ...(size === TokenSize.ExtraSmall && {
      width: 12,
      minWidth: 12,
      height: 12,
    }),

    ...(size === TokenSize.Small && {
      width: 16,
      minWidth: 16,
      height: 16,
    }),

    ...(size === TokenSize.Medium && {
      width: 20,
      minWidth: 20,
      height: 20,
    }),

    ...(size === TokenSize.Large && {
      width: 24,
      minWidth: 24,
      height: 24,
    }),
  },
}));

export default useStyles;
